module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ac36bc9d0064fba29274a15ef29a1ae0.png";